// ? utilized from https://emoji-button.js.org/docs

interface EmojiObject {
  name: string;
  emoji: string;
}

interface EmojiButtonParams {
  // ? All options are set to defaults in initialize
  // root element is not optional, all others are
  rootElement: HTMLElement;

  autoFocusSearch?: boolean;
  autoHide?: boolean;
  categories?: [];
  custom?: EmojiObject[];
  emojisPerRow?: number;
  emojiSize?: string;
  emojiVersion?: '1.0' | '2.0' | '3.0' | '4.0' | '5.0' | '11.0' | '12.0' | '12.1';
  hiddenCategories?: string[];
  i18n?: {
    search: string;
    categories: {
      custom: string;
      recents: string;
      smileys: string;
      animals: string;
      food: string;
      activities: string;
      travel: string;
      objects: string;
      symbols: string;
      flags: string;
    };
    notFound: string;
  };
  icons?: {
    search: string;
    clearSearch: string;
    notFound: string;
  };
  initialCategory?: string;
  position:
    | 'auto-start'
    | 'auto-end'
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'left'
    | 'left-start'
    | 'left-end'
    | { top: number; left: number };
  rows?: number;
  recentsCount?: number;
  showAnimation?: boolean;
  showCategoryButtons?: boolean;
  showPreview?: boolean;
  showRecents?: boolean;
  showSearch?: boolean;
  showVariants?: boolean;
  style?: 'native' | 'twemoji';
  theme?: 'light' | 'dark' | 'auto';
  twemojiOptions?: {};
  zIndex?: number;
}

export class EmoijPicker extends UIObject {
  private _picker: EmojiButton;
  private _pickerParams: EmojiButtonParams;
  constructor() {
    super();
    this._pickerParams = <EmojiButtonParams>{};
  }
  initialize(aParams): void {
    var self = this;

    for (const [key, value] of Object.entries(aParams)) {
      self._pickerParams[key] = value;
    }

    this._picker = new EmojiButton(this._pickerParams);
    // need to wait til the items are in the DOM
    setTimeout(() => {
      for (const [key, value] of Object.entries(aParams)) {
        if (key == 'hiddenCategories') {
          var cats = $(this._pickerParams.rootElement).find('.emoji-picker__category-name');
          value.forEach(cat => {
            cats.each((index, element) => {
              if (element.innerText == cat) {
                $(element).hide();
                $(element.nextSibling).hide();
              }
            });
          });
        }
      }
    }, 1500);
  }
  onTransitionIn(): void {
    var x = 0;
  }
  getEmojiPicker(): EmojiButton {
    return this._picker;
  }
}
